import { createContext, useContext } from 'react';

import { IUserSession } from 'modules/authentication/domain/entities';

export interface IAuthenticationContextData {
  /**
    The current logged user session. This is a hard session created via password/oauth authentication
  */
  session: IUserSession | null;
  /**
   The id of a temporary logged user. Used in loose/hybrid authentication flows. This session expires on tab close and isn't synched between tabs/windows.
   If a user makes a hard session login, guestId is overwritten by the session's id
   */
  guestId: number | null;
  loggedAsGuest: boolean;
  login(session: IUserSession): void;
  guestLogin(id: number): void;
  logout(): void;
}

export const AuthenticationContext = createContext<IAuthenticationContextData>(
  {} as IAuthenticationContextData,
);

export const useAuth = () => useContext(AuthenticationContext);
